import { render } from "./KanbanPage.vue?vue&type=template&id=7b539b4a&scoped=true"
import script from "./KanbanPage.vue?vue&type=script&lang=js"
export * from "./KanbanPage.vue?vue&type=script&lang=js"

import "./KanbanPage.vue?vue&type=style&index=0&id=7b539b4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b539b4a"]])

export default __exports__